import { AbstractResponse } from './AbstractResponse';

export class PagedResponse<T=any> extends AbstractResponse {
  page = 1;
  pageSize = 0;
  total = 0;
  numberOfPages = 1;
  searchResults: T[];

  constructor() {
    super();
  }
}
